var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
var RenderScoreShort = function (props) {
    var score = props.score;
    return (_jsxs("div", __assign({ className: 'short-board__item' }, { children: [score.get('score1'), ":", score.get('score2')] })));
};
var RenderScore = function (props) {
    var score = props.score, i = props.i;
    return (_jsxs("div", __assign({ className: 'score' }, { children: [_jsx("div", __assign({ className: 'tit' }, { children: i })), _jsx("div", __assign({ className: 'num' }, { children: score.get('score1') })), _jsx("div", __assign({ className: 'num' }, { children: score.get('score2') }))] })));
};
var AdditionalScores = function (props) {
    var renderAdditionalScores = [];
    var i = 1;
    props.additionalScores.map(function (score) {
        renderAdditionalScores.push(props.short ? _jsx(RenderScoreShort, { score: score, i: i }, score.get('id')) : _jsx(RenderScore, { score: score, i: i }, score.get('id')));
        i++;
    });
    return renderAdditionalScores;
};
AdditionalScores.propTypes = {
    additionalScores: PropTypes.any
};
export default AdditionalScores;



// WEBPACK FOOTER //
// ./src/components/grid/event/statistics/PeriodScores.jsx